import { useEffect, useState, PointerEvent as ReactPointerEvent } from "react";

import { getWeekDays, getWeeks, dateToBe, parseBeDate, getShortcutOfWeekDay } from "~/utils/date";
import { classNames } from "~/utils/utils";
import { IListMenuOutput } from "~/providers/interfaces";
import { myUseState } from "~/hooks/myUseState";

import "./style.less";

export interface ICalendarDayData {
	beDate: string;
	isPaid?: boolean;
	hasMeals?: boolean;
	hasExercise?: boolean;
	menuData?: IListMenuOutput;
}

export interface IDayItem extends ICalendarDayData {
	curDay: boolean;
	title: string;
}

export type IWeeks = Array<Array<IDayItem>>;

interface IState {
	isMove: boolean;
	startDate: string;
	selection: Array<string>;
}

interface ICalendar {
	curDate: string;
	data?: Array<ICalendarDayData>;
	selected?: Array<string>;
	onSelection?: (dates: Array<string>) => void;
}


export default function Calendar2({
	curDate = dateToBe(new Date()),
	data = [],
	selected = [],
	onSelection = () => {},
} : ICalendar) {
	const { state, updateState } = myUseState<IState>({
		isMove: false,
		startDate: "",
		selection: [
			...selected,
		],
	});

	const weeks = getWeeks(curDate, data);

	function getWindowResolution() {
		const { innerWidth: width, innerHeight: height } = window;

		return {
			width,
			height,
		};
	}

	const [windowResolution, setWindowResolution] = useState(getWindowResolution());

	function getItemClass(dayItem: IDayItem) {
		if (!dayItem.title) {
			return "";
		}

		return classNames([
			dayItem.title ? "has-title" : "",
			dayItem.isPaid ? "paid" : "",
			state.selection.includes(dayItem.beDate) ? "active" : "",
			dayItem.curDay ? "cur-day" : "",
		]);
	}

	function getDateFromEvent(event: ReactPointerEvent): string {
		const target = (event.target as HTMLElement)?.closest(".has-title"); /*.closest("td")*/

		return target?.getAttribute("data-be-date") || "";
	}

	function pointerDown(event: ReactPointerEvent) {
		event.stopPropagation();
		event.preventDefault();

		const beDate = getDateFromEvent(event);

		if (beDate) {
			updateState({
				isMove: true,
				startDate: beDate,
				selection: [beDate],
			});
		} else {
			updateState({
				isMove: false,
				startDate: "",
			});
		}
	}

	function pointerMove(event: ReactPointerEvent) {
		event.stopPropagation();
		event.preventDefault();

		if (state.isMove) {
			const eventDate = getDateFromEvent(event);

			if (!eventDate) {
				return;
			}

			const selection: Array<string> = [];
			const startDate = parseBeDate(state.startDate);
			const selDate = parseBeDate(eventDate);
			const startDay = startDate.getDate();
			const curDay = selDate.getDate();

			if (curDay === startDay) {
				selection.push(eventDate);
			} else if (curDay > startDay) {
				for (let ind = startDay; ind <= curDay; ind++) {
					const day = new Date(startDate);

					day.setDate(day.getDate() + ind - startDay);
					selection.push(dateToBe(day));
				}
			} else {
				for (let ind = curDay; ind <= startDay; ind++) {
					const day = new Date(selDate);

					day.setDate(day.getDate() + ind - curDay);
					selection.push(dateToBe(day));
				}
			}

			updateState({
				selection,
			});
		}
	}

	function pointerUp(event: ReactPointerEvent | PointerEvent) {
		event.stopPropagation();
		event.preventDefault();

		if (state.selection.length > 0) {
			onSelection(state.selection.slice());
		}

		updateState({
			isMove: false,
			startDate: "",
		});
	}

	function bodyPointerUp(event: PointerEvent) {
		if (state.isMove) {
			pointerUp(event);
		}
	}


	useEffect(() => {
		document.body.addEventListener("pointerup", bodyPointerUp);

		return () => {
			document.body.removeEventListener("pointerup", bodyPointerUp);
		};
	}, [state.isMove, state.selection]);

	useEffect(() => {
		updateState({
			selection: selected,
		});
	}, [selected]);

	useEffect(() => {
		function handleResize() {
			setWindowResolution(getWindowResolution());
		}

		window.addEventListener("resize", handleResize);

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return <div>
		<div className="calendarPokus" onPointerDown={pointerDown} onPointerMove={pointerMove} onPointerUp={pointerUp}>

			{getWeekDays().map(weekDay => <div className="weekDays" key={`th_${weekDay}`}>{getShortcutOfWeekDay(weekDay, windowResolution.width)}</div>)}

			{weeks.map(week => week.map(day => <div className={`days ${getItemClass(day)}`} data-be-date={day.title ? day.beDate : ""} key={Math.random()}>
				<div className="daysInner">
					<span className="title">
						{day.title}
					</span>
				</div>
			</div>))}
		</div>
	</div>;
}

/*
return
	<table className="calendar" onPointerDown={pointerDown} onPointerMove={pointerMove} onPointerUp={pointerUp}>
		<thead>
			<tr>
				{getWeekDays().map(weekDay => <th key={`th_${weekDay}`}>{getShortcutOfWeekDay(weekDay, windowResolution.width)}</th>)}
			</tr>
		</thead>
		<tbody>
			{weeks.map((week, weekInd) => <tr className={weekInd === weeks.length - 1 ? "last-row" : ""} key={Math.random()}>
				{week.map(day => <td className={getItemClass(day)} data-be-date={day.title ? day.beDate : ""} key={Math.random()}>
					<span className="events">
						{ day.title && day.hasExercise ? <span className="event-item exercise"></span> : null }
						{ day.title && day.hasMeals ? <span className="event-item meals"></span> : null }
					</span>
					<span className="day">
						{day.title}
					</span>
				</td>)}
			</tr>)}
		</tbody>
	</table>*/
